module.exports = __webpack_public_path__ + "static/img/zt2_banner.21664b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/zt2_banner.jpg
// module id = 0aOl
// module chunks = 171